import {SOPostIngest} from '../../core/ingest/so-post-ingest';
import {IngestCore} from './ingest.core';
import {SOGetIngest} from '../../core/ingest/so-get-ingest';
import {FormField, SelectionOption} from 'lionheartland';
import {postIngestFormFieldOptions} from './post-ingest-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostIngest extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postIngestFormFieldOptions);

  RequestClass = SOPostIngest

  constructor(
    public entityCore: IngestCore
  ) {
    super();
    if (postIngestFormFieldOptions.organization) {
      postIngestFormFieldOptions.organization.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('entityName'),
      this.getFormValueFromIdentifier('data'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}